<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-8">
        <h2>My Registered Activities</h2>
        <ol class="breadcrumb">
          <li>
            Here shows your registered activities and past records.
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Upcoming Activities</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th id="not-completed-event-sequence">No.</th>
                      <th id="not-completed-event-eventname">Name</th>
                      <th id="not-completed-event-eventtime">Start Time</th>
                      <th id="not-completed-event-registrationtime">Registration Time</th>
                      <th id="not-completed-event-eventlocation">Location</th>
                      <th id="not-completed-event-status">Status</th>
                      <th id="not-completed-event-delete" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="(reg,index) in upcomingRegistrations"
                        :key="reg.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ reg.event.name }}</td>
                      <td>{{ reg.event.start_time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                      <td>{{ reg.order_time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                      <td>{{ reg.event.location }}</td>
                      <td>{{ reg.order_status === 0 ? 'Registered' : 'Waiting List' }}</td>
                      <td>
                        <button
                                type="submit"
                                class="btn btn-xs btn-danger"
                                @click="deleteRegistration(reg.id)">
                          Cancel
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Past Registration List</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th id="registration-list-sequence">No.</th>
                      <th id="registration-list-eventname">Name</th>
                      <th id="registration-list-eventtime">Start Time</th>
                      <th id="registration-list-registrationtime">Registration Time</th>
                      <th id="registration-list-eventlocation">Location</th>
                      <th id="registration-list-signinstatus">Status</th>
                      <th id="registration-list-delete" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="(reg,index) in pastRegistrations"
                        :key="reg.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ reg.event.name }}</td>
                      <td>{{ reg.event.start_time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                      <td>{{ reg.order_time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                      <td>{{ reg.event.location }}</td>
                      <td>
                        <i
                           :class="{
                            'text-navy fa-check': reg.sign_in_status,
                            'text-warning': !reg.sign_in_status,
                            'fa-times': reg.order_status != 0 && reg.order_status != 1,
                            'fa-question': !reg.sign_in_status && reg.order_status == 0,
                            'fa-clock-o': reg.order_status === 1}"
                           class="fa" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="ibox-footer">
              <i class="fa text-navy fa-check" />: Signed In,
              <i class="fa text-warning fa-times" />: Cancelled,
              <i class="fa text-warning fa-question" />: Not Signed In Yet
              <i class="fa text-warning fa-clock-o" />: In Waiting List
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
         id="regCancelModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="regCancelLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Registration Cancel Warning
            </h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to quit this activity?
              <br><br> You can register again at the activity list.</p>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  Failed to quit " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="regCancelBtn"
                    type="submit"
                    class="btn btn-md btn-danger"
                    @click="confirmDeleteRegistration">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scope>
.ibox-content tbody tr th {
  font-weight: normal;
}
</style>

<script>
export default {
  name: "MyEvents",
  components: {},
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      getUserRegisteredEventUrl: "",
      getUserRegistrationEventUrl: "",
      registrations: [],
      currentDeletingRegistration: 0,
      errorMessage: "",
      errorShow: false
    };
  },
  computed: {
    upcomingRegistrations () {
      const now = Date.now() / 1000;
      return this.registrations.filter(
        registration =>
          registration.event.start_time > now && (registration.order_status == 0 || registration.order_status == 1)
      );
    },
    pastRegistrations () {
      const now = Date.now() / 1000;
      return this.registrations.filter(
        registration =>
          (registration.order_status != 0 && registration.order_status != 1) || registration.event.start_time <= now
      );
    }
  },
  mounted () {
    this.fetchRegistrationInfo();
  },
  methods: {
    fetchRegistrationInfo () {
      this.getUserRegisteredEventUrl = `user/${this.user.id}/registration`;
      const that = this;
      this.$emit("showLoading");
      this.request
        .get(this.getUserRegisteredEventUrl)
        .then(function (response) {
          that.registrations = response.data.registrations;
        })
        .catch(function (error) {
          toastr.error(error);
        })
        .finally(() => {
          that.$emit("hideLoading");
          // console.log(that.pastRegistrations);
        });
    },
    deleteRegistration (id) {
      this.errorShow = false
      this.errorMessage = ""
      $("#regCancelModal").modal("show");
      this.currentDeletingRegistration = id;
    },
    confirmDeleteRegistration () {
      $("#regCancelBtn").button("loading");
      const that = this;
      this.request
        .delete(`registration/${this.currentDeletingRegistration}`)
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.fetchRegistrationInfo();
          setTimeout(function () {
            $("#regCancelModal").modal("hide");
            console.log("registration successfully canceled");
            $("#regCancelBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#regCancelBtn").button("reset");
        });
    }
  }
};
</script>

<style>
</style>
